(() => {

    document.addEventListener("DOMContentLoaded", () => {

        const booking = JSON.parse(

            localStorage.getItem("device-booking") || "null"

        );

        if (!booking) return;

        /*
        |--------------------------------------------------------------------------
        | Helper
        |--------------------------------------------------------------------------
        */

        function setValue(selectors, value) {

            if (!value) return;

            for (const selector of selectors) {

                const field = document.querySelector(selector);

                if (field) {

                    field.value = value;

                    field.dispatchEvent(

                        new Event("input", {
                            bubbles: true
                        })

                    );

                    field.dispatchEvent(

                        new Event("change", {
                            bubbles: true
                        })

                    );

                    return;

                }

            }

        }

        /*
        |--------------------------------------------------------------------------
        | Shipping Address
        |--------------------------------------------------------------------------
        */

        setValue(

            [
                'input[name="checkout[shipping_address][first_name]"]',
                '#checkout_shipping_address_first_name'
            ],

            booking.full_name

        );

        setValue(

            [
                'input[name="checkout[shipping_address][phone]"]',
                '#checkout_shipping_address_phone'
            ],

            booking.phone

        );

        setValue(

            [
                'input[name="checkout[shipping_address][address1]"]',
                '#checkout_shipping_address_address1'
            ],

            booking.address

        );

        setValue(

            [
                'input[name="checkout[shipping_address][address2]"]',
                '#checkout_shipping_address_address2'
            ],

            booking.unit

        );

        setValue(

            [
                'input[name="checkout[shipping_address][zip]"]',
                '#checkout_shipping_address_zip'
            ],

            booking.postal

        );

        setValue(

            [
                'input[name="checkout[shipping_address][city]"]',
                '#checkout_shipping_address_city'
            ],

            "Singapore"

        );

        setValue(

            [
                'select[name="checkout[shipping_address][country]"]',
                '#checkout_shipping_address_country'
            ],

            "Singapore"

        );

    });

})();